const PRIMARY = '#59a68d'
const PRIMARY_HOVER = '#528b79'
const WHATSAPP = '#25D366'
const WHATSAPP_HOVER = '#1da851'

export const styles = {
  container: {
    minHeight: { xs: '100vh', md: 'auto' },
    height: { md: 'calc(100vh - 10vh)' },
    backgroundColor: '#f5f5f5',
    pb: 0,
    width: { md: 'calc(100vw - 10vw)' },
    mx: 'auto',
    mt: { md: '5vh' },
    mb: { md: '5vh' },
    boxShadow: { md: '0 0 20px rgba(0,0,0,0.1)' },
    borderRadius: { md: 3 },
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: PRIMARY,
    color: 'white',
    py: 1,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minHeight: 60,
  },
  headerText: {
    flex: 1,
  },
  content: {
    py: 3,
    px: 2,
  },
  card: {
    mb: 2,
    borderRadius: 2,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  primaryButton: {
    backgroundColor: PRIMARY,
    '&:hover': { backgroundColor: PRIMARY_HOVER },
    py: 1.5,
    px: 4,
    borderRadius: 2,
    textTransform: 'none',
    fontSize: '1rem',
    fontWeight: 600,
  },
  secondaryButton: {
    backgroundColor: WHATSAPP,
    '&:hover': { backgroundColor: WHATSAPP_HOVER },
    py: 1.5,
    px: 4,
    borderRadius: 2,
    textTransform: 'none',
    fontSize: '1rem',
    fontWeight: 600,
    color: 'white',
  },
  voltarButton: {
    color: PRIMARY,
    textTransform: 'none',
    fontWeight: 600,
  },
  successIcon: {
    fontSize: 80,
    color: PRIMARY,
  },
  horarioChip: {
    m: 0.5,
    '&.MuiChip-root': {
      borderColor: PRIMARY,
    },
  },
  footer: {
    textAlign: 'center',
    py: 2,
    color: '#666',
    fontSize: '0.8rem',
    shrink: 0,
  },
}

export { PRIMARY, PRIMARY_HOVER, WHATSAPP, WHATSAPP_HOVER }
